import { Configuration as CheckinConf } from 'src/sdk_checkin';
import { Configuration as AmcmemberConf } from 'src/sdk-amcmember';
import { Configuration as AuthorizationConf } from 'src/sdk-authorization';
import { Configuration as InitializationConf } from 'src/sdk-initialization';
import { Configuration as UserConf } from 'src/sdk-user';
import { Configuration as SysdateConf } from 'src/sdk-sysdate';
import { environment } from '@env/environment';

export const apiCheckinFactory = () => {
  return new CheckinConf({
    basePath: `${environment.api.baseUrl}${environment.api.app.checkin}`,
  });
};

export const apiAmcmemberFactory = () => {
  return new AmcmemberConf({
    basePath: `${environment.api.baseUrl}${environment.api.app.amcmember}`,
  });
};

export const apiAuthorizationFactory = () => {
  return new AuthorizationConf({
    basePath: `${environment.api.baseUrl}${environment.api.app.authorization}`,
  });
};

export const apiInitializationFactory = () => {
  return new InitializationConf({
    basePath: `${environment.api.baseUrl}${environment.api.app.initialization}`,
  });
};

export const apiUserFactory = () => {
  return new UserConf({
    basePath: `${environment.api.baseUrl}${environment.api.app.user}`,
  });
};

export const apiSysdateFactory = () => {
  return new SysdateConf({
    basePath: `${environment.api.baseUrl}${environment.api.app.sysdate}`,
  });
};
